export default __webpack_public_path__ + "static/media/soul-crushing-meeting.5428b63d.md";